import { api } from "../../../../services/api";

export async function closeCashRegister({ companyId, token, installments }) {
  await api.post("/closeCashRegister", {
    company: companyId,
    token,
    installments,
  });
}
